import { Capacitor } from '@capacitor/core';
import { RCAdapter } from './RcAdapter.ts';
import { RcWeb } from './RcWeb.ts';
import { RcNative } from './RcNative.ts';
import { RawLocalState } from './State.tsx';

export const { Purchases } = Capacitor.isNativePlatform()
    ? await import('@revenuecat/purchases-capacitor')
    : { Purchases: null };

/** ---------- Factory that embeds keys into the instance ---------- */
export function createRCAdapter({
    keys,
    initialState,
}: {
    keys: {
        web?: string;
        ios?: string;
        android?: string;
    };
    initialState: RawLocalState;
}): RCAdapter {
    if (Capacitor.isNativePlatform()) {
        if (!keys?.ios || !keys?.android) {
            throw new Error('Missing RevenueCat native keys: supply both ios and android.');
        }
        return new RcNative({ iosKey: keys.ios, androidKey: keys.android, initialState, Purchases });
    } else {
        if (!keys?.web) throw new Error('Missing RevenueCat web key.');
        return new RcWeb({ webKey: keys.web, initialState });
    }
}
